import { createContext } from "react";

const BrandsContext = createContext();

export default BrandsContext;
